<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  created() {
    const html = document.documentElement;
    html.setAttribute("lang", navigator.languages[0]);
    this.$i18n.locale = navigator.languages[0];
  }
};
</script>
<style scoped>
.v-card__title {
  word-break: break-word;
}
</style>
